import React from "react";
import { Box } from "@mui/joy";
import { useString } from "src/mtska-frontend-app-component/utils";
import { useResolvedMediaSrc } from 'src/mtska-frontend-data-provider/hooks/useResolvedMediaSrc';

const CampaignAvatar = ({ size = "default", url = null, withname = false, name = null, detail = null, item }) => {

    const { firstCharacter, toColor } = useString();
    const { src, ready } = useResolvedMediaSrc(url);

    const showImage = url && ready;

    return (
        <Box className={"campaign-avatar-wrapper campaign-avatar-withname-" + withname}>
            <Box className={"campaign-avatar campaign-avatar-" + size} style={{ backgroundColor: toColor(name) }}>
                {showImage && (
                    <img src={src} alt="" />
                )}
                {!showImage && (
                    (firstCharacter(name).toUpperCase())
                )}
            </Box>
            {withname === true && (
                <Box className={"campaign-name" + (detail ? " hasdetail" : "")}>
                    {name ? (
                        <span className="name" title={name}>{name}</span>
                    ) : (
                        <div className="skeleton skeleton-text" style={{ width: 120, height: 20 }} />
                    )}
                    {detail && (
                        <span className="detail">{(detail)}</span>
                    )}
                </Box>
            )}
        </Box>
    )
}

export default CampaignAvatar;
